export const STACKD_PERPS_BASE_PATH = '/pro';
export const ARCA_PRO_ORIGIN = 'https://app.ar-ca.org/pro';

export function stackdPerpsPath(path: string) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (
    normalizedPath === STACKD_PERPS_BASE_PATH ||
    normalizedPath.startsWith(`${STACKD_PERPS_BASE_PATH}/`)
  ) {
    return normalizedPath;
  }

  return `${STACKD_PERPS_BASE_PATH}${normalizedPath}`;
}
